import {
  faEye,
  faHeartPulse,
  faEdit,
  faCircleInfo,
  faCopy,
} from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import React from "react"
import { Link } from "react-router-dom"
import { MdCategory } from "react-icons/md"
import { numFixer } from "../../../User/getAllUsers/components/Functions"

export const columnConfig = ({
  handleToggleVisibility,
  handleToggleDeleteStatus,
  loading,
  handleSorting,
  setIsOpenClassificationModal,
  setSelectedId,
  setSelectedClassification,
  onOpenNotesModal,
  onOpenExcelUploadsModal,
  copiedId,
  setCopiedId,
}: {
  handleToggleVisibility: (id: string, visibility: "true" | "false") => void
  handleToggleDeleteStatus: (id: string, deleteStatus: "true" | "false") => void
  loading: boolean
  handleSorting: (field: string) => void
  setIsOpenClassificationModal: (isOpen: boolean) => void
  setSelectedId: (id: string) => void
  setSelectedClassification: (classification: any) => void
  onOpenNotesModal: (campaignId: string, initialNotes: any[]) => void
  onOpenExcelUploadsModal: (campaignId: string) => void
  copiedId: string | null
  setCopiedId: (id: string | null) => void
}) => [
  {
    accessor: "id",
    title: "Id",
    sortable: true,
  },
  {
    accessor: "_id",
    title: "Kampanya",
    sortable: true,
    render: ({ _id }: { _id: string }) => (
      <Link to={`/campaigns/find/${_id}`}>
        <div className="text-center items-center mr-4">
          <FontAwesomeIcon icon={faEye} style={{ color: "#005eff" }} />
        </div>
      </Link>
    ),
  },

  {
    accessor: "brand",
    title: "Marka",
    sortable: true,
    render: ({ brand }: { brand: string }) => (
      <Link to={`/brands/find/${brand}`}>
        <div className="text-center items-center mr-4">
          <FontAwesomeIcon icon={faEye} style={{ color: "#005eff" }} />
        </div>
      </Link>
    ),
  },
  {
    accessor: "brand_name",
    title: "Marka İsmi",
    sortable: true,
    render: ({ brand_name }: { brand_name: string }) => (
      <div style={{ maxWidth: "150px", overflow: "hidden", textOverflow: "ellipsis" }}>
        {brand_name}
      </div>
    ),
  },
  {
    accessor: "name",
    title: "Kampanya İsmi",
    sortable: true,
    render: ({ name }: { name: string }) => (
      <div style={{ maxWidth: "150px", overflow: "hidden", textOverflow: "ellipsis" }}>{name}</div>
    ),
  },
  { accessor: "platform", title: "Platform", sortable: true },
  {
    accessor: "campaign_url",
    title: "Kampanya URL'i",
    sortable: true,
    render: ({ _id }: { _id: string }) => {
      const url = `https://teamfluencer.co/app?campaignId=${_id}`

      const copyToClipboard = () => {
        navigator.clipboard.writeText(url)
        setCopiedId(_id)
        setTimeout(() => setCopiedId(null), 1200)
      }

      return (
        <div className="flex items-center gap-2 max-w-[150px] overflow-hidden">
          <button onClick={copyToClipboard}>
            <FontAwesomeIcon icon={faCopy} className="text-gray-600 hover:text-black" />
          </button>

          {copiedId === _id && (
            <span className="px-2 py-1 text-xs bg-black text-white rounded">
              {"Kampanya Url'i Kopyalandı!"}
            </span>
          )}
        </div>
      )
    },
  },
  {
    accessor: "classification",
    title: "Classification",
    width: "260px",
    sortable: true,
    render: ({ _id, classification }: { _id: string; classification: any[] }) => {
      const uniques = Array.from(
        new Set((classification ?? []).map((c) => c.sub_categories?.[0]?.category)),
      )
      const toShow = uniques.slice(0, 3).join(", ")
      const suffix = uniques.length > 3 ? " .." : ""

      return (
        <div
          className="flex items-center gap-2 px-4 py-1.5 border border-gray-300 rounded-2xl cursor-pointer hover:bg-gray-100"
          onClick={() => {
            setIsOpenClassificationModal(true)
            setSelectedId(_id)
            setSelectedClassification(classification)
          }}
        >
          {React.createElement(MdCategory as any, { className: "w-4 h-4 text-black" })}
          <span>{uniques.length > 0 ? toShow + suffix : "Kategori Seç"}</span>
        </div>
      )
    },
  },
  {
    accessor: "invite_new",
    title: (
      <div
        className="w-30 whitespace-normal text-center break-words cursor-pointer"
        onClick={() => handleSorting("invite_new")}
      >
        Davet Edilen Profiller
      </div>
    ),
    sortable: true,
    render: ({ invite_new, voiceMessageInfo }: { invite_new: number; voiceMessageInfo: any }) => (
      <div className="flex">
        <p className="ml-2">{invite_new || 0}</p>
        <p className="ml-2 text-green-500">{voiceMessageInfo?.invite_new?.positive || null}</p>
        <p>-</p>
        <p className="text-red-500">{voiceMessageInfo?.invite_new?.negative || null}</p>
      </div>
    ),
  },
  {
    accessor: "invite_success",
    title: (
      <div
        className="w-30 whitespace-normal text-center break-words cursor-pointer"
        onClick={() => handleSorting("invite_success")}
      >
        Daveti Kabul Eden Profiller
      </div>
    ),
    sortable: true,
    render: ({
      invite_success,
      voiceMessageInfo,
    }: {
      invite_success: number
      voiceMessageInfo: any
    }) => (
      <div className="flex">
        <p className="ml-2">{invite_success || 0}</p>
        <p className="ml-2 text-green-500">{voiceMessageInfo?.invite_success?.positive || null}</p>
        <p>-</p>
        <p className="text-red-500">{voiceMessageInfo?.invite_success?.negative || null}</p>
      </div>
    ),
  },
  {
    accessor: "first_application",
    title: (
      <div
        className="w-30 whitespace-normal text-center break-words cursor-pointer"
        onClick={() => handleSorting("first_application")}
      >
        Başvuran Profiller
      </div>
    ),
    sortable: true,
    render: ({
      first_application,
      voiceMessageInfo,
    }: {
      first_application: number
      voiceMessageInfo: any
    }) => (
      <div className="flex">
        <p className="ml-2">{first_application || 0}</p>
        <p className="ml-2 text-green-500">
          {voiceMessageInfo?.first_application?.positive || null}
        </p>
        <p>-</p>
        <p className="text-red-500">{voiceMessageInfo?.first_application?.negative || null}</p>
      </div>
    ),
  },
  {
    accessor: "waiting_address",
    title: (
      <div
        className="w-30 whitespace-normal text-center break-words cursor-pointer"
        onClick={() => handleSorting("waiting_address")}
      >
        {" "}
        Adres Beklenen Profiller
      </div>
    ),
    sortable: true,
    render: ({
      waiting_address,
      voiceMessageInfo,
    }: {
      waiting_address: number
      voiceMessageInfo: any
    }) => (
      <div className="flex">
        <p className="ml-2">{waiting_address || 0}</p>
        <p className="ml-2 text-green-500">{voiceMessageInfo?.waiting_address?.positive || null}</p>
        <p>-</p>
        <p className="text-red-500">{voiceMessageInfo?.waiting_address?.negative || null}</p>
      </div>
    ),
  },
  {
    accessor: "address_to_approve",
    title: (
      <div
        className="w-30 whitespace-normal text-center break-words cursor-pointer"
        onClick={() => handleSorting("address_to_approve")}
      >
        {" "}
        Onay Bekleyen Adresler
      </div>
    ),
    sortable: true,
    render: ({
      address_to_approve,
      voiceMessageInfo,
    }: {
      address_to_approve: number
      voiceMessageInfo: any
    }) => (
      <div className="flex">
        <p className="ml-2">{address_to_approve || 0}</p>
        <p className="ml-2 text-green-500">
          {voiceMessageInfo?.address_to_approve?.positive || null}
        </p>
        <p>-</p>
        <p className="text-red-500">{voiceMessageInfo?.address_to_approve?.negative || null}</p>
      </div>
    ),
  },
  {
    accessor: "waiting_content",
    title: (
      <div
        className="w-30 whitespace-normal text-center break-words cursor-pointer"
        onClick={() => handleSorting("waiting_content")}
      >
        Onaylanan Profiller
      </div>
    ),
    sortable: true,
    render: ({
      waiting_content,
      voiceMessageInfo,
    }: {
      waiting_content: number
      voiceMessageInfo: any
    }) => (
      <div className="flex">
        <p className="ml-2">{waiting_content || 0}</p>
        <p className="ml-2 text-green-500">{voiceMessageInfo?.waiting_content?.positive || null}</p>
        <p>-</p>
        <p className="text-red-500">{voiceMessageInfo?.waiting_content?.negative || null}</p>
      </div>
    ),
  },
  {
    accessor: "calledCount",
    title: (
      <div
        className="w-30 whitespace-normal text-center break-words cursor-pointer"
        onClick={() => handleSorting("calledCount")}
      >
        Aranma Bilgisi
      </div>
    ),
    sortable: true,
    render: ({ calledCount, notCalledCount }: { calledCount: number; notCalledCount: number }) => (
      <div className="flex">
        <p className="ml-2">{calledCount || 0}</p>
        <p className="ml-2">/</p>
        <p className="ml-2">{notCalledCount || 0}</p>
      </div>
    ),
  },
  {
    accessor: "content_to_share",
    title: (
      <div
        className="w-30 whitespace-normal text-center break-words cursor-pointer"
        onClick={() => handleSorting("content_to_share")}
      >
        Onay Bekleyen İçerikler
      </div>
    ),
    sortable: true,
    render: ({
      content_to_share,
      voiceMessageInfo,
    }: {
      content_to_share: number
      voiceMessageInfo: any
    }) => (
      <div className="flex">
        <p className="ml-2">{content_to_share || 0}</p>
        <p className="ml-2 text-green-500">
          {voiceMessageInfo?.content_to_share?.positive || null}
        </p>
        <p>-</p>
        <p className="text-red-500">{voiceMessageInfo?.content_to_share?.negative || null}</p>
      </div>
    ),
  },
  {
    accessor: "content_rejected",
    title: (
      <div
        className="w-30 whitespace-normal text-center break-words cursor-pointer"
        onClick={() => handleSorting("content_rejected")}
      >
        Reddedilen İçerikler
      </div>
    ),
    sortable: true,
    render: ({
      content_rejected,
      voiceMessageInfo,
    }: {
      content_rejected: number
      voiceMessageInfo: any
    }) => (
      <div className="flex">
        <p className="ml-2">{content_rejected || 0}</p>
        <p className="ml-2 text-green-500">
          {voiceMessageInfo?.content_rejected?.positive || null}
        </p>
        <p>-</p>
        <p className="text-red-500">{voiceMessageInfo?.content_rejected?.negative || null}</p>
      </div>
    ),
  },
  {
    accessor: "ugc_rejected",
    title: (
      <div
        className="w-30 whitespace-normal text-center break-words cursor-pointer"
        onClick={() => handleSorting("ugc_rejected")}
      >
        UGC Reddedilen İçerikler
      </div>
    ),
    sortable: true,
    render: ({
      ugc_rejected,
      voiceMessageInfo,
    }: {
      ugc_rejected: number
      voiceMessageInfo: any
    }) => (
      <div className="flex">
        <p className="ml-2">{ugc_rejected || 0}</p>
        <p className="ml-2 text-green-500">{voiceMessageInfo?.ugc_rejected?.positive || null}</p>
        <p>-</p>
        <p className="text-red-500">{voiceMessageInfo?.ugc_rejected?.negative || null}</p>
      </div>
    ),
  },
  {
    accessor: "content_approved",
    title: (
      <div
        className="w-30 whitespace-normal text-center break-words cursor-pointer"
        onClick={() => handleSorting("content_approved")}
      >
        Onaylanan İçerikler
      </div>
    ),
    sortable: true,
    render: ({
      content_approved,
      voiceMessageInfo,
    }: {
      content_approved: number
      voiceMessageInfo: any
    }) => (
      <div className="flex">
        <p className="ml-2">{content_approved || 0}</p>
        <p className="ml-2 text-green-500">
          {voiceMessageInfo?.content_approved?.positive || null}
        </p>
        <p>-</p>
        <p className="text-red-500">{voiceMessageInfo?.content_approved?.negative || null}</p>
      </div>
    ),
  },
  {
    accessor: "content_shared",
    title: (
      <div
        className="w-30 whitespace-normal text-center break-words cursor-pointer"
        onClick={() => handleSorting("content_shared")}
      >
        Paylaşılan İçerikler
      </div>
    ),
    sortable: true,
    render: ({
      content_shared,
      voiceMessageInfo,
    }: {
      content_shared: number
      voiceMessageInfo: any
    }) => (
      <div className="flex">
        <p className="ml-2">{content_shared || 0}</p>
        <p className="ml-2 text-green-500">{voiceMessageInfo?.content_shared?.positive || null}</p>
        <p>-</p>
        <p className="text-red-500">{voiceMessageInfo?.content_shared?.negative || null}</p>
      </div>
    ),
  },
  {
    accessor: "application_done",
    title: (
      <div
        className="w-30 whitespace-normal text-center break-words cursor-pointer"
        onClick={() => handleSorting("application_done")}
      >
        Tamamlanan İşbirlikleri
      </div>
    ),
    sortable: true,
    render: ({
      application_done,
      voiceMessageInfo,
    }: {
      application_done: number
      voiceMessageInfo: any
    }) => (
      <div className="flex">
        <p className="ml-2">{application_done || 0}</p>
        <p className="ml-2 text-green-500">
          {voiceMessageInfo?.application_done?.positive || null}
        </p>
        <p>-</p>
        <p className="text-red-500">{voiceMessageInfo?.application_done?.negative || null}</p>
      </div>
    ),
  },
  {
    accessor: "lostBetweenState",
    title: (
      <div
        className="w-30 whitespace-normal text-center break-words cursor-pointer flex items-center justify-center gap-1"
        onClick={() => handleSorting("lostBetweenState")}
      >
        <span>İlerlemeyen İşbirlikleri</span>
        <FontAwesomeIcon
          icon={faCircleInfo}
          className="text-gray-500 hover:text-blue-500"
          title="Kampanya sürecinde bir aşamada takılıp kalan ve ilerlemeyen işbirliklerinin sayısı"
        />
      </div>
    ),
    sortable: true,
    render: ({ lostBetweenState }: { lostBetweenState: number }) => (
      <div title="Kampanya sürecinde bir aşamada takılıp kalan ve ilerlemeyen işbirliklerinin sayısı">
        <p>{numFixer(lostBetweenState)}</p>
      </div>
    ),
  },
  {
    accessor: "retryCount",
    title: (
      <div
        className="w-30 whitespace-normal text-center break-words cursor-pointer flex items-center justify-center gap-1"
        onClick={() => handleSorting("retryCount")}
      >
        <span>Durum Tekrarlamaları</span>
        <FontAwesomeIcon
          icon={faCircleInfo}
          className="text-gray-500 hover:text-blue-500"
          title="Kampanya sürecinde aynı duruma geri dönen işbirliklerinin toplam tekrar sayısı"
        />
      </div>
    ),
    sortable: true,
    render: ({ retryCount }: { retryCount: number }) => (
      <div title="Kampanya sürecinde aynı duruma geri dönen işbirliklerinin toplam tekrar sayısı">
        <p>{numFixer(retryCount)}</p>
      </div>
    ),
  },
  {
    accessor: "totalLike",
    title: (
      <div
        className="w-30 whitespace-normal text-center break-words cursor-pointer"
        onClick={() => handleSorting("totalLike")}
      >
        Beğeni Sayısı
      </div>
    ),
    sortable: true,
    render: ({ totalLike }: { totalLike: number }) => (
      <div>
        <p>{numFixer(totalLike)}</p>
      </div>
    ),
  },
  {
    accessor: "totalComment",
    title: (
      <div
        className="w-30 whitespace-normal text-center break-words cursor-pointer"
        onClick={() => handleSorting("totalComment")}
      >
        Yorum Sayısı
      </div>
    ),
    sortable: true,
    render: ({ totalComment }: { totalComment: number }) => (
      <div>
        <p>{numFixer(totalComment)}</p>
      </div>
    ),
  },
  {
    accessor: "totalShare",
    title: (
      <div
        className="w-30 whitespace-normal text-center break-words cursor-pointer"
        onClick={() => handleSorting("totalShare")}
      >
        Paylaşım Sayısı
      </div>
    ),
    sortable: true,
    render: ({ totalShare }: { totalShare: number }) => (
      <div>
        <p>{numFixer(totalShare)}</p>
      </div>
    ),
  },
  {
    accessor: "totalView",
    title: (
      <div
        className="w-30 whitespace-normal text-center break-words cursor-pointer"
        onClick={() => handleSorting("totalView")}
      >
        Görüntülenme Sayısı
      </div>
    ),
    sortable: true,
    render: ({ totalView }: { totalView: number }) => (
      <div>
        <p>{numFixer(totalView)}</p>
      </div>
    ),
  },
  {
    accessor: "totalClick",
    title: (
      <div
        className="w-30 whitespace-normal text-center break-words cursor-pointer"
        onClick={() => handleSorting("totalClick")}
      >
        Tıklanma Sayısı
      </div>
    ),
    sortable: true,
    render: ({ totalClick }: { totalClick: number }) => (
      <div>
        <p>{numFixer(totalClick)}</p>
      </div>
    ),
  },
  {
    accessor: "totalEngagement",
    title: (
      <div
        className="w-30 whitespace-normal text-center break-words cursor-pointer"
        onClick={() => handleSorting("totalEngagement")}
      >
        Toplam Etkileşim
      </div>
    ),
    sortable: true,
    render: ({ totalEngagement }: { totalEngagement: number }) => (
      <div>
        <p>{numFixer(totalEngagement)}</p>
      </div>
    ),
  },
  {
    accessor: "totalBlocked",
    title: (
      <div
        className="w-30 whitespace-normal text-center break-words cursor-pointer"
        onClick={() => handleSorting("totalBlocked")}
      >
        Bloke Edilen Tutar
      </div>
    ),
    sortable: true,
    render: ({ totalBlocked }: { totalBlocked: number }) => (
      <div>
        <p>{numFixer(totalBlocked)}</p>
      </div>
    ),
  },
  {
    accessor: "totalCost",
    title: (
      <div
        className="w-30 whitespace-normal text-center break-words cursor-pointer"
        onClick={() => handleSorting("totalCost")}
      >
        Toplam Harcanan
      </div>
    ),
    sortable: true,
    render: ({ totalCost }: { totalCost: number }) => (
      <div>
        <p>{numFixer(totalCost)}</p>
      </div>
    ),
  },
  {
    accessor: "costPerViews",
    title: (
      <div
        className="w-30 whitespace-normal text-center break-words cursor-pointer"
        onClick={() => handleSorting("costPerViews")}
      >
        Görüntülenme Başına Maliyet
      </div>
    ),
    sortable: true,
    render: ({ costPerViews }: { costPerViews: number }) => (
      <div>
        <p>{numFixer(costPerViews)}</p>
      </div>
    ),
  },
  {
    accessor: "costPerLike",
    title: (
      <div
        className="w-30 whitespace-normal text-center break-words cursor-pointer"
        onClick={() => handleSorting("costPerLike")}
      >
        Beğeni Başına Maliyet
      </div>
    ),
    sortable: true,
    render: ({ costPerLike }: { costPerLike: number }) => (
      <div>
        <p>{numFixer(costPerLike)}</p>
      </div>
    ),
  },
  {
    accessor: "costPerComment",
    title: (
      <div
        className="w-30 whitespace-normal text-center break-words cursor-pointer"
        onClick={() => handleSorting("costPerComment")}
      >
        Yorum Başına Maliyet
      </div>
    ),
    sortable: true,
    render: ({ costPerComment }: { costPerComment: number }) => (
      <div>
        <p>{numFixer(costPerComment)}</p>
      </div>
    ),
  },
  {
    accessor: "costPerShare",
    title: (
      <div
        className="w-30 whitespace-normal text-center break-words cursor-pointer"
        onClick={() => handleSorting("costPerShare")}
      >
        Paylaşım Başına Maliyet
      </div>
    ),
    sortable: true,
    render: ({ costPerShare }: { costPerShare: number }) => (
      <div>
        <p>{numFixer(costPerShare)}</p>
      </div>
    ),
  },
  {
    accessor: "costPerEngagement",
    title: (
      <div
        className="w-30 whitespace-normal text-center break-words cursor-pointer"
        onClick={() => handleSorting("costPerEngagement")}
      >
        Etkileşim Başına Maliyet
      </div>
    ),
    sortable: true,
    render: ({ costPerEngagement }: { costPerEngagement: number }) => (
      <div>
        <p>{numFixer(costPerEngagement)}</p>
      </div>
    ),
  },
  {
    accessor: "approvedToTotalRatio",
    title: (
      <div
        className="w-30 whitespace-normal text-center break-words cursor-pointer"
        onClick={() => handleSorting("approvedToTotalRatio")}
      >
        Onaylanan/Toplam Oranı
      </div>
    ),
    sortable: true,
    render: ({ approvedToTotalRatio }: { approvedToTotalRatio: number }) => (
      <div>
        <p>{approvedToTotalRatio ? (approvedToTotalRatio * 100).toFixed(2) + "%" : "-"}</p>
      </div>
    ),
  },
  {
    accessor: "rejectedToTotalRatio",
    title: (
      <div
        className="w-30 whitespace-normal text-center break-words cursor-pointer"
        onClick={() => handleSorting("rejectedToTotalRatio")}
      >
        Reddedilen/Toplam Oranı
      </div>
    ),
    sortable: true,
    render: ({ rejectedToTotalRatio }: { rejectedToTotalRatio: number }) => (
      <div>
        <p>{rejectedToTotalRatio ? (rejectedToTotalRatio * 100).toFixed(2) + "%" : "-"}</p>
      </div>
    ),
  },
  {
    accessor: "doneToTotalRatio",
    title: (
      <div
        className="w-30 whitespace-normal text-center break-words cursor-pointer"
        onClick={() => handleSorting("doneToTotalRatio")}
      >
        Tamamlanan/Toplam Oranı
      </div>
    ),
    sortable: true,
    render: ({ doneToTotalRatio }: { doneToTotalRatio: number }) => (
      <div>
        <p>{doneToTotalRatio ? (doneToTotalRatio * 100).toFixed(2) + "%" : "-"}</p>
      </div>
    ),
  },
  {
    accessor: "visibility",
    title: "Görünürlük",
    sortable: true,
    render: ({ visibility }: { visibility: boolean }) => (
      <div className="flex">
        <FontAwesomeIcon
          icon={faHeartPulse}
          size="lg"
          style={{ color: visibility ? "#009e1a" : "#ff0000" }}
        />
        <p className="ml-2">{visibility ? "Aktif" : "Görünür Değil"}</p>
      </div>
    ),
  },
  {
    accessor: "toggle_visibility",
    title: "Görünürlüğü Değiştir",
    sortable: true,
    render: ({ _id, visibility }: { _id: string; visibility: boolean }) => {
      return (
        <div className="flex">
          <div style={{ maxWidth: "150px", overflow: "hidden", textOverflow: "ellipsis" }}>
            <button
              onClick={() => handleToggleVisibility(_id, visibility ? "false" : "true")}
              className="bg-blue-500 text-white rounded-md px-3 py-2 w-full hover:bg-blue-600"
            >
              {loading ? (
                <span className="spinner"></span>
              ) : visibility ? (
                "Yayından Kaldır"
              ) : (
                "Aktifleştir"
              )}
            </button>
          </div>
        </div>
      )
    },
  },
  {
    accessor: "delete_status",
    title: "Silinme Durumu",
    sortable: true,
    render: ({ _id, deleted }: { _id: string; deleted: boolean }) => {
      return (
        <div className="flex items-center gap-2">
          <div className="flex items-center">
            <FontAwesomeIcon
              icon={faHeartPulse}
              size="lg"
              style={{ color: deleted ? "#ff0000" : "#009e1a" }}
            />
            <p className="ml-2">{deleted ? "Silinmiş" : "Aktif"}</p>
          </div>
          <button
            onClick={() => handleToggleDeleteStatus(_id, deleted ? "false" : "true")}
            className={`px-3 py-1 rounded text-white text-sm ${
              deleted ? "bg-green-500 hover:bg-green-600" : "bg-red-500 hover:bg-red-600"
            } ${loading ? "opacity-50 cursor-not-allowed" : ""}`}
            disabled={loading}
          >
            {loading ? <span className="spinner"></span> : deleted ? "Geri Al" : "Sil"}
          </button>
        </div>
      )
    },
  },
  {
    accessor: "brand_balance",
    title: (
      <div className="cursor-pointer" onClick={() => handleSorting("brand_balance")}>
        Bakiye
      </div>
    ),
    sortable: true,
    render: ({ brand_balance }: { brand_balance: number }) => (
      <div style={{ maxWidth: "150px", overflow: "hidden", textOverflow: "ellipsis" }}>
        {brand_balance || 0}
      </div>
    ),
  },
  {
    accessor: "created_at",
    title: (
      <div className="cursor-pointer" onClick={() => handleSorting("created_at")}>
        Oluşturulma Tarihi
      </div>
    ),
    sortable: true,
    render: ({ created_at }: { created_at: string }) => (
      <div style={{ maxWidth: "150px", overflow: "hidden", textOverflow: "ellipsis" }}>
        {new Date(created_at).toLocaleDateString()}
      </div>
    ),
  },
  {
    accessor: "excel_uploads",
    title: (
      <div
        className="w-30 whitespace-normal text-center break-words cursor-pointer"
        onClick={() => handleSorting("excel_uploads")}
      >
        Excel Başvuru Yüklemeleri
      </div>
    ),
    sortable: false,
    render: ({ _id, excel_uploads }: { _id: string; excel_uploads: any[] }) => {
      const uploadCount = excel_uploads?.length || 0
      const completedCount =
        excel_uploads?.filter((upload) => upload.processing_status === "completed").length || 0
      const pendingCount =
        excel_uploads?.filter((upload) => upload.processing_status === "pending").length || 0

      return (
        <div className="text-center items-center mr-4">
          <div className="text-sm">
            {uploadCount > 0 ? (
              <div>
                <p className="font-medium">{uploadCount} yükleme</p>
                <p className="text-gray-500 text-xs">
                  Tamamlanan: {completedCount} | Bekleyen: {pendingCount}
                </p>
              </div>
            ) : (
              <span className="text-gray-400">Yükleme yok</span>
            )}
          </div>
          <FontAwesomeIcon
            icon={faEdit}
            style={{ color: "#005eff", cursor: "pointer", marginLeft: "10px" }}
            onClick={() => onOpenExcelUploadsModal(_id)}
          />
        </div>
      )
    },
  },
  {
    accessor: "notes",
    title: "Notlar",
    render: ({ _id, notes: initialNotes }: { _id: string; notes: any[] }) => (
      <div className="text-center items-center mr-4">
        <div className="text-sm">
          {initialNotes && initialNotes.length > 0 ? (
            <div>
              <p className="font-medium">{initialNotes.length} not</p>
              <p className="text-gray-500 text-xs">
                Son not:{" "}
                {new Date(initialNotes[initialNotes.length - 1].note_time).toLocaleDateString(
                  "tr-TR",
                )}
              </p>
            </div>
          ) : (
            <span className="text-gray-400">Not yok</span>
          )}
        </div>
        <FontAwesomeIcon
          icon={faEdit}
          style={{ color: "#005eff", cursor: "pointer", marginLeft: "10px" }}
          onClick={() => onOpenNotesModal(_id, initialNotes)}
        />
      </div>
    ),
  },
  {
    accessor: "max_cost",
    title: (
      <div className="cursor-pointer" onClick={() => handleSorting("max_cost")}>
        Max Tutar
      </div>
    ),
    sortable: true,
    render: ({ max_cost }: { max_cost: number }) => (
      <div style={{ maxWidth: "150px", overflow: "hidden", textOverflow: "ellipsis" }}>
        {max_cost && max_cost.toLocaleString()}
      </div>
    ),
  },
  {
    accessor: "totalClicks",
    title: (
      <div
        className="w-30 whitespace-normal text-center break-words cursor-pointer"
        onClick={() => handleSorting("totalClicks")}
      >
        Toplam Tıklanma
      </div>
    ),
    sortable: true,
    render: ({ totalClicks }: { totalClicks: number }) => (
      <div style={{ maxWidth: "150px", overflow: "hidden", textOverflow: "ellipsis" }}>
        {totalClicks || 0}
      </div>
    ),
  },
  {
    accessor: "costPerClick",
    title: (
      <div
        className="w-30 whitespace-normal text-center break-words cursor-pointer"
        onClick={() => handleSorting("costPerClick")}
      >
        Tıklanma Başına Maliyet
      </div>
    ),
    sortable: true,
    render: ({ costPerClick }: { costPerClick: number }) => {
      return (
        <div style={{ maxWidth: "150px", overflow: "hidden", textOverflow: "ellipsis" }}>
          {costPerClick || 0}
        </div>
      )
    },
  },
  {
    accessor: "totalViews",
    title: (
      <div
        className="w-30 whitespace-normal text-center break-words cursor-pointer"
        onClick={() => handleSorting("totalViews")}
      >
        Toplam İzlenme
      </div>
    ),
    sortable: true,
    render: ({ totalViews }: { totalViews: number }) => (
      <div style={{ maxWidth: "150px", overflow: "hidden", textOverflow: "ellipsis" }}>
        {totalViews || 0}
      </div>
    ),
  },
  {
    accessor: "costPerView",
    title: (
      <div
        className="w-30 whitespace-normal text-center break-words cursor-pointer"
        onClick={() => handleSorting("costPerView")}
      >
        İzlenme Başına Maliyet
      </div>
    ),
    sortable: true,
    render: ({ costPerView }: { costPerView: number }) => {
      return (
        <div className="w-30 whitespace-normal text-center break-words">{costPerView || 0}</div>
      )
    },
  },
]
